export default __webpack_public_path__ + "static/media/FooterLogoWhite.c21f236a.svg";